// PGCET MCA Mock 2 — Computer Awareness (questions 31–55)
const pgcetmcaComputerAwareness = [
  {
    id: 31,
    question: "Which data structure is used by a computer to manage function calls, including recursive calls?",
    options: ["A. Queue", "B. Heap", "C. Stack", "D. Graph"],
    answer: "C"
  },
  {
    id: 32,
    question: "The postfix (Reverse Polish) form of the infix expression (A + B) * (C − D) / E is",
    options: ["A. AB+CD−*E/", "B. AB+CD*−E/", "C. ABCD+−*E/", "D. AB+C−D*E/"],
    answer: "A"
  },
  {
    id: 33,
    question: "The maximum number of nodes in a binary tree of height h (the root is at height 0) is",
    options: ["A. 2ʰ", "B. 2ʰ − 1", "C. 2h + 1", "D. 2ʰ⁺¹ − 1"],
    answer: "D"
  },
  {
    id: 34,
    question: "The worst-case time complexity of Quick Sort on n elements is",
    options: ["A. O(n log n)", "B. O(n²)", "C. O(n)", "D. O(log n)"],
    answer: "B"
  },
  {
    id: 35,
    question: "Which traversal of a Binary Search Tree visits the keys in ascending order?",
    options: ["A. Preorder", "B. Postorder", "C. Inorder", "D. Level order"],
    answer: "C"
  },
  {
    id: 36,
    question: "In C, what is printed by the statement printf(\"%d\", 7 / 2 * 2); ?",
    options: ["A. 7", "B. 6", "C. 7.0", "D. 8"],
    answer: "B"
  },
  {
    id: 37,
    question: "A relation that is in 2NF and has no transitive dependency of a non-prime attribute on the candidate key is in",
    options: ["A. 1NF", "B. BCNF", "C. 4NF", "D. 3NF"],
    answer: "D"
  },
  {
    id: 38,
    question: "In SQL, which clause is used to filter groups after a GROUP BY has been applied?",
    options: ["A. WHERE", "B. HAVING", "C. ORDER BY", "D. DISTINCT"],
    answer: "B"
  },
  {
    id: 39,
    question: `Which of the following statements are correct?
      (i) A primary key column can contain NULL values.
      (ii) A table can have only one primary key.
      (iii) A foreign key can refer to the primary key of another table.`,
    options: ["A. (i) and (ii) only", "B. (iii) only", "C. (i), (ii) and (iii)", "D. (ii) and (iii) only"],
    answer: "D"
  },
  {
    id: 40,
    question: "Which layer of the OSI model is responsible for routing packets between networks?",
    options: ["A. Network layer", "B. Data link layer", "C. Transport layer", "D. Session layer"],
    answer: "A"
  },
  {
    id: 41,
    question: "Which protocol is used to find the MAC (hardware) address that corresponds to a known IP address?",
    options: ["A. DNS", "B. DHCP", "C. ARP", "D. ICMP"],
    answer: "C"
  },
  {
    id: 42,
    question: "How many usable host addresses are available in an IPv4 subnet with prefix /26?",
    options: ["A. 64", "B. 30", "C. 126", "D. 62"],
    answer: "D"
  },
  {
    id: 43,
    question: "The sum (2F)₁₆ + (1A)₁₆, expressed in hexadecimal, is",
    options: ["A. (49)₁₆", "B. (4A)₁₆", "C. (39)₁₆", "D. (59)₁₆"],
    answer: "A"
  },
  {
    id: 44,
    question: "The octal number (157)₈ in decimal is",
    options: ["A. 103", "B. 111", "C. 157", "D. 113"],
    answer: "B"
  },
  {
    id: 45,
    question: "Which of the following is NOT one of the four necessary conditions for a deadlock?",
    options: ["A. Mutual exclusion", "B. Hold and wait", "C. Circular wait", "D. Preemption"],
    answer: "D"
  },
  {
    id: 46,
    question: "Using FIFO page replacement with 3 frames (initially empty), how many page faults occur for the reference string 1, 2, 3, 4, 1, 2, 5, 1, 2, 3, 4, 5?",
    options: ["A. 10", "B. 8", "C. 9", "D. 12"],
    answer: "C"
  },
  {
    id: 47,
    question: "A situation in which a system spends more time swapping pages in and out of memory than executing processes is called",
    options: ["A. Thrashing", "B. Starvation", "C. Fragmentation", "D. Spooling"],
    answer: "A"
  },
  {
    id: 48,
    question: "In a direct-mapped cache with 128 blocks, main memory block number 300 is placed in cache block",
    options: ["A. 300", "B. 44", "C. 172", "D. 2"],
    answer: "B"
  },
  {
    id: 49,
    question: "Which of the following is NOT a feature of object-oriented programming?",
    options: ["A. Encapsulation", "B. Inheritance", "C. Pointer arithmetic", "D. Polymorphism"],
    answer: "C"
  },
  {
    id: 50,
    question: "In Java, which keyword prevents a method from being overridden in a subclass?",
    options: ["A. static", "B. final", "C. private", "D. abstract"],
    answer: "B"
  },
  {
    id: 51,
    question: "Which software development life cycle model is explicitly risk-driven, with risk analysis performed in every cycle?",
    options: ["A. Waterfall model", "B. V-model", "C. Spiral model", "D. Big-bang model"],
    answer: "C"
  },
  {
    id: 52,
    question: "Black-box testing designs test cases based on",
    options: [
      "A. the internal code structure of the program",
      "B. the specifications, without knowledge of the internal code",
      "C. the number of lines of code",
      "D. the compiler used to build the program"
    ],
    answer: "B"
  },
  {
    id: 53,
    question: "Which of the following logic gates is a universal gate?",
    options: ["A. NAND", "B. XOR", "C. AND", "D. OR"],
    answer: "A"
  },
  {
    id: 54,
    question: "The Sum and Carry outputs of a half adder with inputs A and B are respectively",
    options: ["A. A AND B, A XOR B", "B. A OR B, A AND B", "C. A XOR B, A OR B", "D. A XOR B, A AND B"],
    answer: "D"
  },
  {
    id: 55,
    question: "How many address lines are needed to address each byte of a 4 KB memory?",
    options: ["A. 10", "B. 14", "C. 12", "D. 16"],
    answer: "C"
  }
];

export default pgcetmcaComputerAwareness;
